angular.module('tuitionFeesModule', [
  'ui.bootstrap',
  'duScroll',
  'angular.filter',
  'angularjs-dropdown-multiselect',

  'shared.components.sbIcon',
  'shared.components.sbSideMenuNavPill',
  'shared.components.sbDatePicker',
  'shared.components.sbTitleBar',
  'shared.components.sbActionMenu',
  'shared.components.sbColumnHeader',
  'shared.components.sbModalHeader',
  'shared.components.sbOnOffSwitch',
  'shared.components.sbSearchFilter',
  'shared.components.sbSearchFilterItem',
  'shared.components.sbTextarea',
  'shared.components.subMenu',
  'shared.constants',
  'shared.directives.cloakTranslate',
  'shared.directives.ngBindHtmlDataLabelAttr',
  'shared.directives.ngBindHtmlPlaceholder',
  'shared.directives.ngBindHtmlTitleAttr',
  'shared.directives.sbCheckBox',
  'shared.directives.sbCurrencyInput',
  'shared.directives.sbLoading',
  'shared.components.sbSubmitButton',
  'shared.directives.updateLanguage',
  'shared.services.authInterceptor',
  'shared.services.cachedLookupService',
  'shared.services.guidService',
  'shared.services.httpCoreApi',
  'shared.services.moduleService',
  'shared.services.simpleAlertService',
  'shared.services.toastService',
  'shared.services.tinymceConfigHelper',
  'shared.services.searchResultOptionsCountService',
  'ng1StateDefinitionModule',

  'tuitionFeesModule.filters.calculateBilledAmount'
]);
angular.module('tuitionFeesModule').config([
    'ng1StateDefinitionProvider',
    function (ng1StateDefinitionProvider) {

        const ng1State = ng1StateDefinitionProvider.$get();

        const moduleName = 'TuitionFees';

        ng1State.state(moduleName, 'tuitionFees', {
            url: '/',
            component: 'tuitionFeesDashboard',
            redirectTo: 'tuitionFees.billingCycle'
        })
        ng1State.state(moduleName, 'tuitionFees.billingCycle', {
            url: 'BillingCycle',
            component: 'billingCycle'
        })
        ng1State.state(moduleName, 'tuitionFees.billingCycle.addToCycle', {
            url: '/AddToCycle',
            component: 'addToCycle',
            params: {
                billingCycleIdFn: null,
                billingCycleRefreshFn: null
            }
        })
        ng1State.state(moduleName, 'tuitionFees.billingCycle.batchView', {
            url: '/BatchView',
            component: 'batchView',
            params: {
                billingCycleIdFn: null,
                billingCycleRefreshFn: null
            }
        })
        ng1State.state(moduleName, 'tuitionFees.billingCycle.postInvoices', {
            url: '/PostInvoices',
            component: 'postInvoices',
            params: {
                billingCycleIdFn: null,
                billingCycleRefreshFn: null
            }
        })
        ng1State.state(moduleName, 'tuitionFees.invoice', {
            url: 'Invoice',
            component: 'invoiceView'
        })
        // invoice detail states removed — migrated to Angular routing
    }
])
